import { render, staticRenderFns } from "./OmniChannel.vue?vue&type=template&id=79ec0e6f&scoped=true&"
import script from "./OmniChannel.vue?vue&type=script&lang=js&"
export * from "./OmniChannel.vue?vue&type=script&lang=js&"
import style0 from "./OmniChannel.vue?vue&type=style&index=0&id=79ec0e6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec0e6f",
  null
  
)

export default component.exports